import PropTypes from "prop-types";
import Lottie from "lottie-react";
import approved from "./Animation-GeneratedRequestGIF.json";
import styles from "./CompanyKYCRequestGenerated.module.css";
// import { useNavigate, useParams } from "react-router-dom";

const RequestGenerated = ({ className = "" }) => {
  // const navigate = useNavigate();
  // const { id } = useParams();
  return (
    <div className="d-flex justify-content-center h-100">
      <div className={styles.httpslottiefilescomanimatParent}>
        <Lottie className={styles.httpslottiefilescomanimatIcon} animationData={approved} loop={true} />
        <div className={styles.successfullyGeneratedRequest}>Company KYC Generated Successfully</div>
        {/* <button
          className={styles.returnToKycList}
          // onClick={() => {
          //   navigate(`/content/company/kyclist/main`);
          // }}
        >
          <b className={styles.returnToKyc}>Return to KYC List</b>
        </button> */}
      </div>
    </div>
  );
};

RequestGenerated.propTypes = {
  className: PropTypes.string,
};

export default RequestGenerated;

// ApprovedPOPup
